var ADD_FIELD_TO_STATE = 'ADD_FIELD_TO_STATE';
var SET_FIELD = 'SET_FIELD';
var RESET_STATE = 'RESET_STATE';
var FORM_BUILDER_NAMESPACE = 'form-builder';

export { ADD_FIELD_TO_STATE, FORM_BUILDER_NAMESPACE, RESET_STATE, SET_FIELD };
